module.exports = __webpack_public_path__ + "img/github-white-logo-sm.d4d66d1d.svg";